function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.412,
    height: 22.357,
    viewBox: "0 0 22.412 22.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "search (3)",
    transform: "translate(1.049 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3",
    cx: 8.864,
    cy: 8.864,
    r: 8.864,
    transform: "translate(-.05)",
    style: {
      fill: "none",
      stroke: "#0a243f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    transform: "translate(15.13 15.124)",
    style: {
      fill: "none",
      stroke: "#0a243f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M4.82 4.82 0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch3);
export default __webpack_public_path__ + "static/media/search-3.fb5ee13d200387d00b4b9f45b1cfabe2.svg";
export { ForwardRef as ReactComponent };